<!--选择设备 -->
<template>
    <div>
        <div class="searchArea">
            <div class="content">
                <el-form style="width: 90%"  label-width="90px">
                    <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="搜索设备：">
                            <el-input prefix-icon="el-icon-search" placeholder="请输入名称/序列号" size="small" v-model="searchParams.code" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="设备状态：">
                            <el-select v-model="searchParams.state" placeholder="请选择" size="small" clearable>
                                <el-option
                                v-for="(item,index) in deviceState"
                                :key="index"
                                :label="item.label" :value="item.label"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    </el-row>
                    <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="设备位置：">
                        <el-cascader
                            v-model="searchParams.location"
                            :options="options"
                            :props="{value: 'regionname',label: 'regionname',checkStrictly: true}"
                            size="small"
                            clearable>
                        </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                         <el-form-item label="设备类型：">
                            <el-select v-model="searchParams.dtype" placeholder="请选择" size="small" clearable>
                                <el-option v-for="(item,index) in deviceTypeList"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                                ></el-option>
                            </el-select>
                         </el-form-item>
                    </el-col>
                    </el-row>
                </el-form>
                <div class="block"></div>
                <div class="rightBtn">
                    <el-button type="primary" icon="el-icon-search" size="small" class="btnStyle" style="margin-bottom:0.1rem" @click="onSearch">查询</el-button>
                    <el-button icon="el-icon-refresh-left" size="small" style="margin-left: 0;" @click="resetting">重置</el-button>
                </div>
            </div>
        </div>
        <div class="showSelected" v-if="isShow">
            <div>
            <i class="el-icon-info"></i><span style="margin-left:0.1rem">已选择{{isChecked}}台设备</span>
            </div>
            <div>
            <el-button type="text" size="small" @click="clear" style="color:#405891">清空</el-button>
            </div>
        </div>
        <div class="table">
          <el-table :data="tableData.slice((page-1)*limit,page*limit)" style="width: 100%" row-key="code" :header-cell-style="{background:'#FAFAFA',color:'#405891'}"
          ref="multipleTable"  @selection-change="handleSelectionChange" @select="handleOneSelect" @select-all="handleSelectAll" height="280">
              <el-table-column type="selection" width="55" reserve-selection></el-table-column>
              <el-table-column label="序号" width="80">
              <template slot-scope="scope">
                  {{scope.$index+1}}
              </template>
              </el-table-column>
              <el-table-column prop="name" label="监测点名称">
              </el-table-column>
              <el-table-column prop="dname" label="序列号">
              </el-table-column>
              <el-table-column prop="typename" label="设备类型">
              </el-table-column>
              <el-table-column prop="state"  label="状态">
                <template slot-scope="scope">
                    <div style="display:flex; align-items:center;">
                        <span :style="{background:scope.row.state == '离线'? '#FF791A':'#75D391'}" style="display:inline-block;width:5px;height:5px;border-radius:50%;margin-right:0.1rem"></span>
                        <span>{{scope.row.state}}</span>
                    </div>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="设备位置" show-overflow-tooltip>
              </el-table-column>
          </el-table>
          <div style="margin-top:0.2rem;text-align:right">
              <a-pagination v-model="page" :pageSize="limit" show-quick-jumper show-size-changer :total="totalCount" @change="onChange" @showSizeChange="pageSizeChange"/>
          </div>
          <div style="text-align: right;margin-top: 0.2rem">
            <el-button size="small" @click="handleCancel" style="width:100px">取消</el-button>
            <el-button size="small"  type="primary" class="btnStyle" style="width:100px" @click="saveSelected">保存</el-button>
          </div>
        </div>
    </div>
</template>
<script>
import regionList from '@/assets/json/region.json'
import { getAreaList } from '@/api/page/compareData.js';
import { getDeviceType } from '@/api/page/deviceList.js'
import MixinSD from '@/store/sd/mixinsSd.js'
export default {
    mixins: [MixinSD],
    props:['selectedRow'],
    data() {
        return {
            regionList,
            options:[],
            isShow: true,
            isChecked: null,
            tableData:[], // 表格数据
            page:1,
            limit: 10,
            totalCount: 500,
            checkNumber: 15,
            deviceTypeList:[], //设备类型列表
            searchParams:{
                location:[],
                dtype:'000',
                state:'全部',
                code: '',
            },
            search: 0, // 1.搜索卡开始  0.搜索结束
            // 设备状态
            deviceState:[{
                id:0,
                label:'全部'
            },{
                id:1,
                label: '在线'
            },{
                id:2,
                label: '离线'
            }],
            multipleSelection:[], // 选中的数据
        }
    },
    created() {
        this.getMapinfo()
        this.getDeviceType()
        let regionList = this.regionList.RECORDS;
        regionList.forEach(item=> {
            if(item.level == 1) {
                this.options.push(item)
                this.options.forEach(j=> {
                    j.children = []
                })
            }
        })
        regionList.forEach(item=> {
            this.options.forEach(j=> {
                if(item.parentcode == j.regioncode) {
                    j.children.push(item)
                    j.children.forEach(i=> {
                        i.children = []
                    })
                }
            })
        })
        regionList.forEach(item=> {
            this.options.forEach(j=> {
                if(j.children !=[]) {
                    j.children.forEach(i=> {
                        if(item.parentcode == i.regioncode) {
                            i.children.push(item)
                        }
                    })
                }
            })
        })

    },
    methods:{
        getMapinfo () { // 获取设备点位接口
        console.log('pppp',this.searchParams)
            var ts = this.stringTime(new Date())
            var data = {
                account: window.localStorage.getItem('account'),
                is_all: 1,
                is_gkz: 2,
                page: this.page,
                limit: this.limit,
                dtype: this.searchParams.dtype == '000'? '':this.searchParams.dtype,
                state: this.searchParams.state == '全部'? '':this.searchParams.state,
                province: this.searchParams.location? this.searchParams.location[0]:'',
                city: this.searchParams.location? this.searchParams.location[1]:'',
                town: this.searchParams.location? this.searchParams.location[2]:'',
                code: this.searchParams.code,
                name: this.searchParams.code,
                merge_search:"code_name",
                token: window.localStorage.getItem('token'),
                ts
            }
            const that = this
            this.getAreaListSD(data).then(function (value) {
                const result = value.data.data
                that.tableData = result.filter(item => {
                    return item.code !== null && item.type !== '17'
                })
                that.tableData.forEach((item, i) => {
                item.key = i
                item.id = i < 9 ? '0' + (i + 1) : i + 1
                item.time = that.stringTime(new Date())
                })
                that.totalCount = that.tableData.length
                // 默认选中的设备
                that.tableData.forEach(item=> {
                    that.selectedRow.forEach(v=> {
                        if(item.code == v.code) {
                            that.$nextTick(()=> {
                            that.$refs.multipleTable.toggleRowSelection(item,true)
                            })
                        }
                    })
                })
            })
       },
        handleOneSelect(selection, row) {
            if(selection.length > this.checkNumber) {
                this.$message.warning(`最多只能选择${this.checkNumber}条！`)
                this.$refs.multipleTable.toggleRowSelection(row, false)
            }
        },
        handleSelectionChange(selection) {
            if(this.search == 1) {
                console.log('搜索中');
                return
            }
            if(selection.length > this.checkNumber) {
                return;
            }
            this.isChecked = selection.length
            this.multipleSelection = selection
        },
        handleSelectAll(selection) {
            const tabRef = this.$refs.multipleTable;
            if(selection.length > this.checkNumber) {
                this.$message.warning('全选操作超出可选最大数量限制，不可操作')
                let selectIds = this.multipleSelection.map(e=>e.code)
                tabRef.clearSelection()
                this.$nextTick(()=> {
                    this.tableData.forEach((row)=> {
                        if(selectIds.includes(row.code)) {
                            tabRef.toggleRowSelection(row,true)
                        }
                    })
                })

            }
        },
        onChange(val) {
          this.page = val;
        },
        pageSizeChange(page,pageSize) {
         this.limit = pageSize
         this.getMapinfo()
        },
        // 获取设备类型
        getDeviceType() {
           let data = {
                account: window.localStorage.getItem('account'),
                token: window.localStorage.getItem('token'),
                ts:this.stringTime(new Date())
           }
           getDeviceType(data).then(res=> {
               this.deviceTypeList = res.data
               this.deviceTypeList.unshift({
                  id: '000',
                  name:'全部'
               })
           })
        },
        // 查询
         onSearch() {
            this.page = 1
            this.limit = 10
            this.search = 1
            this.getMapinfo()
        },
        resetting() {
          this.searchParams = {
            dtype: '000',
            state: '全部',
            code: '',
          }
          this.getMapinfo()
        },
        // 保存选中
        saveSelected() {
            this.$emit('selectChange',this.multipleSelection,false)
        },
        // 取消
        handleCancel() {
            this.$emit('selectChange', '',false)
        },
        // 清空所有选中
        clear() {
           this.$refs.multipleTable.clearSelection()
        }
    },
    watch: {
        selectedRow: {
          handler:function(value) {
            this.isChecked = value.length
          },
          immediate:true
        },
    }
}
</script>

<style scoped lang="less">
.searchArea .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-form-item {
  margin-bottom: 0.1rem;
  .el-form-item__label {
      color: #405891;
  }
  .el-cascader {
    width: 100%;
  }
}
</style>